import { takeUntil } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DateTime } from 'luxon';
import { BaseEditPopUpComponent } from '../../Services/BaseEditPopUpComponent';
import { ConfigService } from "../../Services/ConfigService";
import { CustomerInvoiceItemService } from '../../Services/Custom/ServiceCustomerInvoiceItem';

@Component({
	selector: 'CustomerInvoiceArbitraryItem-edit',
	templateUrl: 'CustomerInvoiceArbitraryItemEdit.html',
	
})
export class CustomerInvoiceArbitraryItemEditComponent extends BaseEditPopUpComponent implements OnInit {
	ngOnInit(): void {

	}

	constructor(
		public configData: ConfigService,
		private myCustomerInvoiceItemService: CustomerInvoiceItemService,
		private aModal: NgbActiveModal
	) {
		super();
		this.activeModal = aModal;
	}

	myItem: TooBig4Car.Logic.CustomerInvoiceArbitraryItem = {} as TooBig4Car.Logic.CustomerInvoiceArbitraryItem;

	loadItem(id: System.Guid, invoiceID: System.Guid, customerID: System.Guid) {
		this.myCustomerInvoiceItemService.getArbitraryEdit(id)
			.pipe(takeUntil(this.obsToCloseSubject))
			.subscribe((obj: TooBig4Car.Logic.CustomerInvoiceArbitraryItem) => {
				this.myItem = obj;
				if (this.configData.IsEmptyGuid(obj.CustomerInvoiceArbitraryItemID)) {
					this.myItem.CustomerInvoiceID = invoiceID;
					this.myItem.CustomerAccountID = customerID;
					this.myItem.DateApplies = DateTime.local().startOf('day').toJSDate();
				}
			},
				(error: any) => {
					this.closePopUp(null); 
				}
			);
	}

	saveItem(form: NgForm) {
		this.myCustomerInvoiceItemService.saveArbitrary(this.myItem)
			.pipe(takeUntil(this.obsToCloseSubject))
			.subscribe(obj => {
				this.closePopUp(obj);
			},
				(error: any) => {
					this.showValidationErrors(error, form);
				});
	}
}

